exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.question[data-v-5ce97134] {\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n.button[data-v-5ce97134] {\n  padding: 0 20px;\n}\n", ""]);

// exports
